// src/services/api.ts
import axios from 'axios';

const API_BASE_URL = 'http://localhost:3001';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token se existir
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Serviços de Servidor
export const searchEmployeeByCPF = async (cpf: string) => {
  const response = await api.get(`/servidores/cpf/${cpf}`);
  return response.data;
};

// Serviços de Autenticação/Validação
export const solicitarValidacaoEmail = async (cpf: string, email: string) => {
  const response = await api.post('/auth/solicitar-validacao', { cpf, email });
  return response.data;
};

export const validarCodigo = async (token: string, codigo: string) => {
  const response = await api.post('/auth/validar-codigo', { token, codigo });
  return response.data;
};

// Serviços de Documentos
export const buscarDocumentosServidor = async (servidorId: number) => {
  const response = await api.get(`/documentos/servidor/${servidorId}`);
  return response.data;
};

export const buscarPdfParaAssinatura = async (documentoId: number, servidorId: number) => {
  const response = await api.get(`/documentos/${documentoId}/pdf/${servidorId}`);
  return response.data;
};

export const assinarDocumento = async (
  documentoId: number, 
  servidorId: number, 
  cpf: string, 
  hashAssinatura: string
) => {
  const response = await api.post(`/documentos/${documentoId}/assinar`, {
    servidorId,
    cpf,
    hashAssinatura
  });
  return response.data;
};

export const consultarDocumentosPorToken = async (token: string) => {
  const response = await api.get(`/documentos/consulta/${token}`);
  return response.data;
};

// Serviço para administração (se necessário)
export const uploadDocumento = async (servidorId: number, file: File, tipo: string) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('tipo', tipo);
  
  const response = await api.post(`/documentos/upload/${servidorId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export default api;